import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { API_URL } from '../config/urls';
import routes from '../config/routes';
import { fetchProfile, setProfileError } from '../actions/profile_action';
import Notification from "./layout/Notification";
import { trackPromise } from "react-promise-tracker";

class Summary extends Component {
    constructor(props) {
        super(props);

        this.idsArray = [];
        this.state = {
            url: URL,
            withOutDataWithOutHashMatic: 0,
            withOutDataWithOutHashEth: 0,
            withOutDataWithOutHashTezos: 0,
            withDataWithOutHashMatic: 0,
            withDataWithOutHashEth: 0,
            withDataWithOutHashTezos: 0,
            withOutDataWithHashMatic: 0,
            withOutDataWithHashEth: 0,
            withOutDataWithHashTezos: 0,
            releaseMatic: 0,
            releaseEth: 0,
            releaseTezos: 0,
            unreleaseMatic: 0,
            unreleaseEth: 0,
            unreleaseTezos: 0
        };
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    componentDidMount() {
        this.setErrorOnApiCall();
        // this.props.fetchProfile();
        this.getNftsSummary();
    }

    getNftsSummary = () => {
        const body = {
            action: "release-nft-summary"
        };

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + routes.REPORTS, body)
                .then(response => {
                    let { payload } = response.data;

                    this.setState({
                        withOutDataWithOutHashMatic: payload.withOutDataWithOutHashMatic,
                        withOutDataWithOutHashEth: payload.withOutDataWithOutHashEth,
                        withOutDataWithOutHashTezos: payload.withOutDataWithOutHashTezos,
                        withDataWithOutHashMatic: payload.withDataWithOutHashMatic,
                        withDataWithOutHashEth: payload.withDataWithOutHashEth,
                        withDataWithOutHashTezos: payload.withDataWithOutHashTezos,
                        withOutDataWithHashMatic: payload.withOutDataWithHashMatic,
                        withOutDataWithHashEth: payload.withOutDataWithHashEth,
                        withOutDataWithHashTezos: payload.withOutDataWithHashTezos,
                        releaseMatic: payload.releaseMatic,
                        releaseEth: payload.releaseEth,
                        releaseTezos: payload.releaseTezos,
                        unreleaseMatic: payload.unreleaseMatic,
                        unreleaseEth: payload.unreleaseEth,
                        unreleaseTezos: payload.unreleaseTezos,
                        isLoading: false
                    });
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            modal_error_message: error.response.data.message,
                            modal_error_type: 'danger'
                        }, () => { this.scrollToTop() })
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "fetching nfts summary")
                    })
                })
        )
    }

    render() {
        return (
            <div class="content summary-list">
                <div class="top-header">
                    <div class="header-title">
                        <h2 class="title">Summary</h2>
                        <span class="title-caption">Detail view for NFT summary.</span>
                    </div>
                    <div class="header-btn">
                        <Link to="/dashboard" class="custom-btn dark-btn icon-btn sm-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                    <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                        <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                        <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                    </g>
                                </g>
                            </svg>
                            <span class="txt-btn">Back</span>
                        </Link>
                    </div>
                </div>

                <div class="main-content">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }
                    <div class="summary-listing table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">NFTs Summary</th>
                                    <th scope="col">TEZOS Count</th>
                                    <th scope="col">MATIC Count</th>
                                    <th scope="col">ETH Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td scope="row">1</td>
                                    <td><div>WITHOUT METADATA WITHOUT TRANSACTION HASH</div></td>
                                    <td>{this.state.withOutDataWithOutHashTezos}</td>
                                    <td>{this.state.withOutDataWithOutHashMatic}</td>
                                    <td>{this.state.withOutDataWithOutHashEth}</td>
                                </tr>
                                <tr>
                                    <td scope="row">2</td>
                                    <td><div>WITH METADATA WITHOUT TRANSACTION HASH</div></td>
                                    <td>{this.state.withDataWithOutHashTezos}</td>
                                    <td>{this.state.withDataWithOutHashMatic}</td>
                                    <td>{this.state.withDataWithOutHashEth}</td>
                                </tr>
                                <tr>
                                    <td scope="row">3</td>
                                    <td><div>WITHOUT METADATA WITH TRANSACTION HASH</div></td>
                                    <td>{this.state.withOutDataWithHashTezos}</td>
                                    <td>{this.state.withOutDataWithHashMatic}</td>
                                    <td>{this.state.withOutDataWithHashEth}</td>
                                </tr>
                                <tr>
                                    <td scope="row">4</td>
                                    <td><div>RELEASED</div></td>
                                    <td>{this.state.releaseTezos}</td>
                                    <td>{this.state.releaseMatic}</td>
                                    <td>{this.state.releaseEth}</td>
                                </tr>
                                <tr>
                                    <td scope="row">5</td>
                                    <td><div>UNRELEASED</div></td>
                                    <td>{this.state.unreleaseTezos}</td>
                                    <td>{this.state.unreleaseMatic}</td>
                                    <td>{this.state.unreleaseEth}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = {
    fetchProfile
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary)